<!--suppress TypeScriptUnresolvedVariable -->
<div *ngIf="constructor.name.length > 1" class="component-name">>> {{constructor.name}} <<</div>

<div class="signature-body po-pdf" @fade *ngIf="signatureVisible">
    <div class="title">Purchase Order</div>
    <div class="purchase-date"><b>Date of Sale or Purchase:</b> <span style="margin-left: 10px"><p-calendar [(ngModel)]="poManager.current.purchaseDate" [ngModelOptions]="{standalone: true}" appendTo="body" inputStyleClass="calendar-input-style"></p-calendar></span></div>

    <ls-fieldset legend="Amount" class="details-fieldset">
        <ng-template>
            <table>
                <tr>
                    <th>PO #</th>
                    <th>Description</th>
                    <th>Quantity</th>
                    <th>Amount</th>
                </tr>
                <tr>
                    <td>{{poManager.current.number}}</td>
                    <td>Converters</td>
                    <td>{{poManager.current.numConverters + poManager.current.numMiscellaneous}}</td>
                    <td>{{poManager.current.totalPrice | currency:poManager.current.currency}}</td>
                </tr>
            </table>
        </ng-template>
    </ls-fieldset>
    <ls-fieldset legend="{{location.subsidiary.displayName}} (Buyer)" class="details-fieldset">
        <ng-template>
            <div class="input-field">
                <div class="input-box">
                    <div>{{poManager.current.location.address ?? ''}}</div>
                    <span>Street Address</span>
                </div>
                <div class="input-box">
                    <div>{{poManager.current.location.city ?? ''}}</div>
                    <span>City</span>
                </div>
                <div class="input-box">
                    <div>{{poManager.current.location.state ?? ''}}</div>
                    <span>State</span>
                </div>
                <div class="input-box">
                    <div>{{poManager.current.location.zip ?? ''}}</div>
                    <span>ZIP Code</span>
                </div>
            </div>
        </ng-template>
    </ls-fieldset>
    <ls-fieldset legend="{{poManager.current.vendor.name}} (Seller)" class="details-fieldset">
        <ng-template>
            <div class="input-field">
                <div class="input-box">
                    <div>{{poManager.current.vendor.address ?? ''}}</div>
                    <span>Street Address</span>
                </div>
                <div class="input-box">
                    <div>{{poManager.current.vendor.city ?? ''}}</div>
                    <span>City</span>
                </div>
                <div class="input-box">
                    <div>{{poManager.current.vendor.state ?? ''}}</div>
                    <span>State</span>
                </div>
                <div class="input-box">
                    <div>{{poManager.current.vendor.zip ?? ''}}</div>
                    <span>ZIP Code</span>
                </div>
            </div>
        </ng-template>
    </ls-fieldset>
    <ls-fieldset legend="Contact Details" class="details-fieldset">
        <ng-template>
            <form [formGroup]="contactForm">
                <p-dropdown [options]="poManager.current.vendor.contacts" [(ngModel)]="selectedContact" [ngModelOptions]="{standalone: true}"
                        optionLabel="fullName" placeholder="Select Contact" (onChange)="onContactChanged($event)"></p-dropdown>
                <div class="input-field stretch">
                    <div class="input-box">
                        <input type="text" pInputText formControlName="firstName" [ngModelOptions]="{standalone: true}" disabled="true"/>
                        <span>First Name</span>
                    </div>
                    <div class="input-box">
                        <input type="text" pInputText formControlName="lastName" [ngModelOptions]="{standalone: true}"/>
                        <span>Last Name</span>
                    </div>
                    <div class="input-box">
                        <input type="text" pInputText formControlName="email" [ngModelOptions]="{standalone: true}"/>
                        <span>Email</span>
                    </div>
                </div>
            </form>
        </ng-template>
    </ls-fieldset>

    <ls-fieldset legend="Additional Info" class="details-fieldset">
        <ng-template>
                <form [formGroup]="detailsForm" class="input-field stretch">
                    <div class="input-box">
                        <input type="text" pInputText [ngModelOptions]="{standalone: true}" formControlName="sortCode"/>
                        <span>Sort Code</span>
                    </div>
                    <div class="input-box">
                        <input type="text" pInputText [ngModelOptions]="{standalone: true}" formControlName="accountTitle"/>
                        <span>Account Title</span>
                    </div>
                    <div class="input-box">
                        <input type="text" pInputText [ngModelOptions]="{standalone: true}" formControlName="accountNumber"/>
                        <span>Account Number</span>
                    </div>
                    <div class="input-box">
                        <input type="text" pInputText [ngModelOptions]="{standalone: true}" formControlName="iban"/>
                        <span>IBAN</span>
                    </div>
                    <div class="input-box">
                        <input type="text" pInputText [ngModelOptions]="{standalone: true}" formControlName="vatNumber"/>
                        <span>VAT Number</span>
                    </div>
                    <div class="input-box">
                        <input type="text" pInputText [ngModelOptions]="{standalone: true}" formControlName="notes"/>
                        <span>Notes</span>
                    </div>
                </form>
        </ng-template>
    </ls-fieldset>

    <div class="button-box">
        <p-button severity="secondary" class="cancel" label="Cancel" (click)="onCancel()"></p-button>
        <p-button class="confirm" label="Confirm" (click)="onConfirmGeneralPage()"></p-button>
    </div>
</div>
